import { Badge } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const AcceptanceRateCell = styled.div`
  ${({ success }) =>
    success &&
    css`
      color: var(--color-accent-primary-default);
      font-weight: 700;
    `}
`;

const SubtitleWrapper = styled.div`
  align-items: center;
  background-color: var(--color-bg-weaker);
  border-bottom: 1px solid var(--color-border-default);
  display: flex;
  flex-direction: row;
  gap: 8px;
  height: 48px;
  padding: 0 16px;

  ${Badge.S.Badge} {
    &:hover {
      background-color: var(--color-bg-default);
    }
  }
`;

const FilterWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

const Wrapper = styled.div`
  border-radius: var(--size-border-radius-xl);
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Name = styled.div`
  cursor: pointer;
  overflow-x: auto;
  text-decoration: underline;
`;

export { AcceptanceRateCell, FilterWrapper, Name, SubtitleWrapper, Wrapper };
